export class DetailedError extends Error {
  private details: ErrorDetails
  constructor(message: string, details: ErrorDetails) {
    super(message)
    this.details = details
  }

  get code() {
    return this.details.code
  }
}

type ErrorDetails = {
  code: number
}
